import React, { useState } from 'react'
import { EmployeeLogin } from '../Access/ActionCreator'
import Loader from './common/Loader'
import { calendarFormat } from 'moment'

export default function Login({ PageHandler }) {
    const [loader, setLoader] = useState(false)
    const [showError, setShowError] = useState(false)
    const [logindata, setLoginData] = useState({
        email: '',
        password: ''
    })

    const handleLogin = (e) => {
        const { name, value } = e.target;
        setLoginData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleLoginBtn = () => {
        setLoader(true)

        if (logindata?.email === "" || logindata?.email === undefined || logindata?.email === null || logindata?.password === "" || logindata?.password === null || logindata?.password === undefined) {
            setLoader(false)
            setShowError(true)
        } else {
            EmployeeLogin(logindata.email, logindata.password, (callback) => {
                setLoader(false)
                console.log("call",callback)
                if (callback && callback == "success") {
                    setLoader(true)
                    const obj={...logindata}
                    const SessionData = JSON.stringify(obj)
                    window.sessionStorage.setItem("AdminLogin",SessionData)
                    setTimeout(()=>{
                        setLoader(false)
                        PageHandler("crifPage")
                    },200)
                } else {
                    setShowError(true)
                }
            })
        }
        removeError()
    }

    const removeError = () => {
        setTimeout(() => {
            setShowError(false)
        }, 5000)
    }
    return (
        <>
            <div className='LoginPage'>
                {loader ?
                    <Loader />
                    : ''}
                <div className="backgroundImage"></div>
                <div className="outerBox">
                    <div className="innerBox" style={{width: window.innerWidth > 767 ? "40%" :'100%'}}>
                        <div className="row">

                            <div className=" col-xs-12">
                                <h4 style={{ margin: '0px 0px 20px 0px', fontSize: '30px', textAlign: 'center' }}>Admin Login</h4>
                                <div className='inputGrp'>
                                    <i class="fa-solid fa-envelope"></i>
                                    <input type='email' className='inputTag' name='email' value={logindata.email} placeholder='email' onChange={(e) => handleLogin(e)} />
                                </div>
                                <div className='inputGrp'>
                                    <i class="fa-solid fa-lock"></i>
                                    <input type='password' className='inputTag' name='password' value={logindata.password} placeholder='password' onChange={(e) => handleLogin(e)} />
                                </div>
                                <div className='errorText' style={{ visibility: showError ? "" : "hidden" }}>
                                    <h6>Please Enter Correct Username and Password</h6>
                                </div>
                                <button className='loginBtn' onClick={() => handleLoginBtn()}>Login</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
